import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { getConfirmationPlanning, updateConfirmationPlanning } from '@/@core/queries/confirmation-planning'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useConfirmationPlanningEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { updateItem, getItem } = useLambda()
  const { addAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const confirmationPlanning = ref({})
  const isSubmitting = ref(false)
  const originalData = ref(null)
  const query = {
    _id: oid(route.value.params.id),
    client_id: oid(userData.client.$oid),
    deleted: { $ne: true },
  }
  const collection = 'confirmation_planning'

  async function show() {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })

      if (!item) {
        showErrorMessage(i18n.t('message.you_are_not_authorized'))
        router.push({ name: 'organization-confirmation-planning-list' })
        return
      }

      const confirmationPlanningData = item || {}

      // Inicializar history si no existe (documentos legacy)
      if (!confirmationPlanningData.history) {
        confirmationPlanningData.history = []
      }

      confirmationPlanning.value = {
        // role: confirmationPlanningData.role?._id,
        process: confirmationPlanningData.process?.toString(),
        confirmationsPerYear: confirmationPlanningData.confirmationsPerYear,
        evaluated: confirmationPlanningData.evaluated?.toString(),
        history: confirmationPlanningData.history,
      }
      originalData.value = JSON.parse(JSON.stringify(item))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.confirmation_planning_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  async function update(data) {
    if (!hasPermission('confirmation-planning', 'edit')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        // role: { link: data.role.value },
        process: oid(data.process.value),
        confirmationsPerYear: Number(data.confirmationsPerYear.value),
        evaluated: oid(data.evaluated.value)
      }

      const action = { $set: payload }

      await updateItem({ collection, query, action })

      await addAuditEntry({
        collection,
        documentId: oid(route.value.params.id),
        originalData: originalData.value,
        updatedData: payload,
      })

      showSuccessMessage(i18n.t('message.confirmation_planning_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.confirmation_planning_update_error'))
    } finally {
      router.push({ name: 'organization-confirmation-planning-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    confirmationPlanning,
    isSubmitting,
  }
}
